<div class="modal">
  <div class="modal-ctn">

    <div class="options">
      <div>{{ 'PRODUCT.UPDATE_MISSION_PRODUCT' | translate }} {{ this.params.missionProduct.productName }}</div>
      <button type="button" class="icon-action" title="Close" (click)="close()"><ng-icon name="heroXMark" size="20"/></button>
    </div>

    <div class="form-grid">

      <div><df-input block [(value)]="productExpectedQty" /></div>

    </div>

    <div class="footer">
      <df-button variant="primary" (onClick)="update()" [disabled]="!isValid()">{{ 'SAVE' | translate }}</df-button>
    </div>
      
  </div>
</div>